module.exports = __webpack_public_path__ + "img/ywAward-1.37cf4479.png";